<template src="./index.html"></template>

<script>
import { getdata } from './data.js';
import { getYear, getFinancialPeriod, getDetailType, reportSubmit, inquiryAliasConfig, getCACodeDesc, getTCodeByNumber } from '../../../../api/home.js';
export default {
	name: 'VoucherReport',
	data() {
		return {
			baoblx: ['0'],
			//基本信息
			formlistjbxx: getdata().formlistjbxx,
			formdatajbxx: getdata().formdatajbxx,
			//凭证信息
			formlistpzxx: getdata().formlistpzxx,
			formdatapzxx: getdata().formdatapzxx,
			//验证
			ispassjbxx: false,
			ispasspzxx: false
		};
	},
	watch: {
		'formdatajbxx.cains': function(indexVal, oldVal) {
			this.formdatajbxx.qij = '';
			this.GainCwqj(indexVal);
		}
	},
	mounted() {},
	created() {
		this.searrchForData();
	},
	methods: {
		empty() {
			this.baoblx = [];
			this.formdatajbxx = getdata().formdatajbxx;
			this.formdatapzxx = getdata().formdatapzxx;
			this.$nextTick(() => {
				this.$refs.taxformjbxx.clearValidate();
				this.$refs.taxformpzxx.clearValidate();
			});
		},
		//通过验证最后的保存
		SaveExecution() {
			if (this.ispassjbxx && this.ispasspzxx) {
				let params = {};
				params.json = JSON.stringify({ name: '凭证报表后台任务', taskDesc: 'test', subType: '13' });
				let param = this.formdatapzxx;
				param.cains = [];
				param.cains.push(this.formdatajbxx.cains.toString());
				param.qij = [];
				param.qij.push(this.formdatajbxx.qij.toString());
				param.baoblx = this.baoblx;
				param.mingxlx = this.formdatajbxx.mingxlx;
				params.param = JSON.stringify(param);
				reportSubmit(params).then(res => {
					if (res.data.code == '200') {
						this.$message.success('生成成功');
						this.$router.push({
							path: '/ReportTask',
						});
					} else {
						this.$message.error(res.data.message);
					}
				});
			}
		},
		//基本信息通过验证
		getdatajbxx() {
			this.ispassjbxx = true;
			this.SaveExecution();
		},
		//凭证信息通过验证
		getdatapzxx() {
			this.ispasspzxx = true;
			this.SaveExecution();
		},
		//生成按钮验证
		generate() {
			this.ispassjbxx = false;
			this.ispasspzxx = false;
			this.$refs.taxformjbxx.submitForm();
			this.$refs.taxformpzxx.submitForm();
		},

		//初始化查询
		searrchForData() {
			this.formlistjbxx = getdata().formlistjbxx;
			this.GainNd();
		},
		//获取年度
		GainNd() {
			let params = {};
			getYear().then(res => {
				this.formdatajbxx.cains = new Date().getFullYear();
				for (var i = res.data.data.max; i >= res.data.data.min; i--) {
					this.formlistjbxx[0].selectval.push({
						label: i,
						value: i
					});
				}
			});
		},
		//获取财务期间
		GainCwqj(year) {
			let params = {};
			params.year = year;
			getFinancialPeriod(params).then(res => {
				if (res.data.code == '200') {
					this.formlistjbxx[1].selectval = res.data.data.map(v => {
						return {
							label: v.name,
							value: v.value
						};
					});
				} else {
					this.formdatajbxx.qij = '';
					this.formlistjbxx[1].selectval = [];
				}
				let currencyMonth = new Date().getMonth() + 1;
				this.formdatajbxx.qij = currencyMonth;
			});
		}
	}
};
</script>

<style scoped lang="less">
@import url('./index.less');
</style>
